import api from './ApiService';

export async function getPlans(): Promise<any> {
  try {
    const response = await api.get('/plans');
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar os planos', error);
    throw new Error('Erro ao carregar os planos');
  }
}
